import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useSubscribe, type Observable } from '@/js/libs/observable';
import { UnavailableIcon, useNotification } from '@/js/libs/ui/src/V2';

import { ErrorCode } from 'src/types';

const body =
  'The origin server did not find a current representation for the target resource or is not willing to disclose that one exists.';
export function useRecover({
  retry,
  pending$,
  error$,
}: {
  retry: () => Promise<unknown>;
  pending$: Observable<boolean>;
  error$: Observable<unknown | undefined>;
}) {
  const [t] = useTranslation(['backend', 'common']);
  const notify = useNotification();
  const error = useSubscribe(error$);

  const onRecover = useCallbackRef(() => {
    retry().catch((err) => {
      if (err?.status === ErrorCode.NotFound && err.response.data.includes(body)) {
        notify.error({ title: t('common:SERVICE_UNAVAILABLE'), body: t('common:PLEASE_RETRY_LATER') });
      }
    });
  });

  return error ? <UnavailableIcon onClick={onRecover} pending$={pending$} tooltip={t('common:TEMPORARY_UNAVAILABLE')} /> : null;
}
